import React from 'react';
import PropTypes from 'prop-types';
import './Chevron.scss';

const Chevron = ({ direction, onClick, onKeyDown, ...rest }) => (
	<div
		className={`chevron ${direction}-chevron`}
		role="button"
		tabIndex={0}
		onClick={onClick}
		onKeyDown={onKeyDown}
		onMouseDown={(e) => e.preventDefault()}
		{...rest}
	>
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
		>
			{direction === 'left' ? (
				<path
					d="M11.3649 4.00346C11.9191 3.38769 11.8692 2.43926 11.2534 1.88507C10.6377 1.33088 9.68923 1.3808 9.13505 1.99657L4.63505 6.99657C4.12163 7.56702 4.12163 8.433 4.63505 9.00346L9.13505 14.0035C9.68923 14.6192 10.6377 14.6691 11.2534 14.115C11.8692 13.5608 11.9191 12.6123 11.3649 11.9966L7.76803 8.00001L11.3649 4.00346Z"
					fill="black"
				/>
			) : (
				<path
					d="M4.63507 4.00346C4.08088 3.38769 4.1308 2.43926 4.74657 1.88507C5.36233 1.33088 6.31077 1.3808 6.86495 1.99657L11.365 6.99657C11.8784 7.56702 11.8784 8.433 11.365 9.00346L6.86495 14.0035C6.31077 14.6192 5.36233 14.6691 4.74657 14.115C4.1308 13.5608 4.08088 12.6123 4.63507 11.9966L8.23197 8.00001L4.63507 4.00346Z"
					fill="black"
				/>
			)}
		</svg>
	</div>
);

Chevron.propTypes = {
	direction: PropTypes.oneOf(['left', 'right']).isRequired,
	onClick: PropTypes.func.isRequired,
	onKeyDown: PropTypes.func.isRequired,
};

export default Chevron;
